import axios from "axios";

const backendApi = axios.create({
    baseURL: "https://api-v2-17kf.carandx.com/api",
    // baseURL: "http://staging-api.carandx.com/api",
    // baseURL: "http://63.183.59.188:3000/api",
    // // baseURL: "http://192.168.1.44:3000/api",
    // baseURL: "http://40.172.76.10:3000/api",
    // baseURL: "http://localhost:3000/api",
    headers: {
        "Content-Type": "application/json",
        // Production
        Authorization:
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY4YTQ2NmQ1OGQwMDc4MjI2ZDE3NzRhZiIsImlhdCI6MTc1NTYwNDY5M30.VQASbUAWcZYryPBRj5T-YLg-ncwjm7cAr-hcCfYVfLI",

        // Localhost
        // Authorization:
        //     "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY4YTQ2NmQ1OGQwMDc4MjI2ZDE3NzRhZiIsImlhdCI6MTc1NTYwNDY5M30.VQASbUAWcZYryPBRj5T-YLg-ncwjm7cAr-hcCfYVfLI",
    },
});

const odooApi = axios.create({
    // baseURL: "https://testing.carandx.com",
    baseURL: "https://odoo-ps-psae-carandx.odoo.com/",
    headers: {
        "Content-Type": "application/json",
    },
});

const fileUploadApi = axios.create({
    baseURL: "https://xceesimgup.carandx.com",
    headers: {
        "Content-Type": "form-data",
    },
});

type VehiclePaginateParams = {
    page?: number;
    limit?: number;
    skip?: number;
    odooId?: number;
    defaultPrice?: number;
    active?: boolean;
    searchString?: string;
    notAudited?: boolean;
};

const API = {
    login: async function (username: string, password: string) {
        const result: any = await odooApi.post("/v1/api/login", {
            jsonrpc: "2.0",
            params: {
                login: username,
                password: password,
            },
        });

        return result.data.result;
    },
    matchSpecification: async function (
        expectedJson: object,
        specificationText: string,
        index: number,
    ) {
        const result: any = await backendApi.post(
            "/specification/match-specification",
            {
                expectedJson,
                specificationText,
                index,
            },
        );

        return result.data.data;
    },
    findSpecValue: async function (data: {
        make: string;
        model: string;
        year: string;
        specName: string;
        subCategory: string;
        mainCategory: string;
    }) {
        const result: any = await backendApi.post(
            "/specification/find-spec-value",
            data,
        );
        return result.data;
    },
    aiAudit: async function (data: {
        make: string;
        model: string;
        year: string;
        vehicleTitle?: string;
        specName: string;
        subCategory: string;
        mainCategory: string;
        currentValue: string;
        expectedValues?: string[];
    }) {
        const result: any = await backendApi.post("/specification/ai-audit", data);
        return result.data;
    },
    getCachedSpecification: async function (make: string, model: string) {
        model = model.replaceAll(" ", "%20");

        const result: any = await backendApi.get(
            `/specification/get-cached-specification?make=${make}&model=${model}`,
        );

        return result.data.data;
    },
    getExpectedResults: async function () {
        const result = await backendApi.get("/expected-result");
        return result.data;
    },
    createExpectedResult: async function (data: any) {
        const result = await backendApi.post("/expected-result", data);
        return result.data;
    },
    getOneExpectedResult: async function (id: string) {
        const result = await backendApi.get(`/expected-result/${id}`);
        return result.data;
    },
    updateExpectedResult: async function (id: string, data: any) {
        const result = await backendApi.put(`/expected-result/${id}`, data);
        return result.data;
    },
    deleteExpectedResult: async function (id: string) {
        const result = await backendApi.delete(`/expected-result/${id}`);
        return result.data;
    },
    getAllRatings: async function () {
        const result = await backendApi.get("/rating");
        return result.data;
    },
    getRatingWithCategory: async function (category: string) {
        const result = await backendApi.get(`/rating/category/${category}`);
        return result.data;
    },
    createRating: async function (rating: object) {
        const result = await backendApi.post(`/rating`, rating);
        return result.data;
    },
    deleteRating: async function (id: string) {
        const result = await backendApi.delete(`/rating/${id}`);
        return result.data;
    },
    getOrderWithCategory: async function (category: string) {
        const result = await backendApi.get(`/order/category/${category}`);
        return result.data;
    },
    createOrder: async function (order: object) {
        const result = await backendApi.post(`/order`, order);
        return result.data;
    },
    adminSearch: async function (searchString: string) {
        const result = await backendApi.get(
            `/vehicle/admin-search?searchString=${searchString}`,
        );
        return result.data;
    },
    paginateVehicles: async function (params: VehiclePaginateParams) {
        const result = await backendApi.get("/vehicle/paginate", {
            params,
        });
        return result.data;
    },
    getOneVehicle: async function (vehicleId: string) {
        const result = await backendApi.get(`/vehicle/${vehicleId}`);
        return result.data;
    },
    createVehicle: async function (data: any) {
        const result = await backendApi.post("/vehicle", data);
        return result.data;
    },
    updateVehicle: async function (vehicleId: string, data: any) {
        const result = await backendApi.put(`/vehicle/${vehicleId}`, data);
        return result.data;
    },
    deleteVehicle: async function (vehihcleId: string) {
        const result = await backendApi.delete(`/vehicle/${vehihcleId}`);
        return result.data;
    },
    updateStock: async function (stockId: string, data: any) {
        const result = await backendApi.put(`/stock/${stockId}`, data);
        return result.data;
    },
    upload: async function (file: any, folderName: string) {
        let data = new FormData();
        data.append("file", file);
        data.append("folderName", folderName);
        const result = await fileUploadApi.post("/upload", data);
        return result.data;
    },
    createCMS: async function (data: any) {
        const result = await backendApi.post(`/cms`, data);
        return result.data;
    },
    getOneCMS: async function (cmsId: string) {
        const result = await backendApi.get(`/cms/:id`);
        return result.data;
    },
    getLatestCMS: async function () {
        const result = await backendApi.get(`/cms/latest`);
        return result.data;
    },
    paginate: async function () {
        const result = await backendApi.get(`/cms/paginate`);
        return result.data;
    },
    getOneVehicleVariant: async function (vehicleVariantId: string) {
        const result = await backendApi.get(
            `/vehicle-variant/${vehicleVariantId}`,
        );
        return result.data;
    },
    paginateVehicleVariants: async function (params: any) {
        const result = await backendApi.get("/vehicle-variant/paginate", {
            params,
        });
        return result.data;
    },
    paginateVehicleVariantsWithoutGallery: async function (params: any) {
        const result = await backendApi.get(
            "/vehicle-variant/paginate-variants-without-gallery",
            {
                params,
            },
        );
        return result.data;
    },
    paginateVehicleWithoutSpec: async function (params: any) {
        const result = await backendApi.get(
            "/vehicle/paginate-vehicles-without-specification",
            {
                params,
            },
        );
        return result.data;
    },
    updateVehicleVariant: async function (vehicleVariantId: string, data: any) {
        const result = await backendApi.put(
            `/vehicle-variant/${vehicleVariantId}`,
            data,
        );
        return result.data;
    },
    getVehicleVariantWithOdooId: async function (odooId: string) {
        const result = await backendApi.get(
            `/vehicle-variant/get-with-odooId`,
            {
                params: {
                    odooId,
                },
            },
        );
        return result.data;
    },
    syncWithOdooData: async function () {
        const result = await backendApi.post(`/vehicle/sync-product-with-odoo`);
        return result.data;
    },
    saveSpecification: async function (
        vehicleId: string,
        specification: object = {},
        scores?: {
            general: number;
            performance: number;
            safety: number;
            features: number;
            overall: number;
            customer: number;
        },
        ratingUpdate?: {
            category: string;
            subCategory: string;
            key: string;
            value: string;
            rating: number;
        },
        auditSign?: string,
        auditBy?: string,
    ) {
        const result = await backendApi.post(
            `/vehicle/save-specification/${vehicleId}`,
            {
                specification,
                scores,
                ratingUpdate,
                ...(auditSign ? { audit_sign: auditSign } : {}),
                ...(auditBy ? { audit_by: auditBy } : {}),
            },
        );
        return result.data;
    },
    createVehicleWheelOption: async function (data: any) {
        const result = await backendApi.post(`/vehicle-wheel-option`, data);
        return result.data;
    },
    getVehicleWheelOptionWithVehicleId: async function (vehicleId: string) {
        const result = await backendApi.get(
            `/vehicle-wheel-option/get-all-with-vehicleId/${vehicleId}`,
        );
        return result.data;
    },
    updateVehicleWheelOption: async function (optionId: string, data: any) {
        const result = await backendApi.put(
            `/vehicle-wheel-option/${optionId}`,
            data,
        );
        return result.data;
    },
    deleteVehicleWheelOption: async function (optionId: string) {
        const result = await backendApi.delete(
            `/vehicle-wheel-option/${optionId}`,
        );
        return result.data;
    },
    createLocalAttributeImage: async function (odooId: number, image: string) {
        let data = {
            odooId,
            image,
        };

        const result = await backendApi.post(`/local-attribute-image`, data);
        return result.data;
    },
    deleteLocalAttributeImage: async function (odooId: number) {
        let data = {
            odooId,
        };

        const result = await backendApi.post(
            `/local-attribute-image/delete`,
            data,
        );
        return result.data;
    },
    createLocalAttributePrice: async function (odooId: number, price: number) {
        let data = {
            odooId,
            price,
        };

        const result = await backendApi.post(`/local-attribute-price`, data);
        return result.data;
    },
    createHiddenAdditionalOption: async function (
        vehicleId: string,
        index: number,
    ) {
        let data = {
            vehicleId,
            index,
        };

        const result = await backendApi.post(`/hidden-additional-option`, data);
        return result.data;
    },
    deleteHiddenAdditionalOption: async function (
        vehicleId: string,
        index: number,
    ) {
        const result = await backendApi.delete(
            `/hidden-additional-option/${vehicleId}/${index}`,
        );
        return result.data;
    },
    copyVariantGallery: async function (
        fromVariantId: string,
        toVariantId: string,
    ) {
        const result = await backendApi.post(`/vehicle-variant/copy-gallery`, {
            fromVariantId,
            toVariantId,
        });
        return result.data;
    },
    createHiddenOption: async function (odooId: number, odooVehicleId: number) {
        const result = await backendApi.post("/local-option-hidden", {
            odooId,
            odooVehicleId,
        });
        return result.data;
    },
    deleteHiddenOption: async function (odooId: number, odooVehicleId: number) {
        const result = await backendApi.post("/local-option-hidden/delete", {
            odooId,
            odooVehicleId,
        });
        return result.data;
    },
    getVehicleCmsDataWithOdooId: async function (odooId: number) {
        const result = await backendApi.get(
            `/vehicle-model-cms/with-vehicle-odoo-id/${odooId}`,
        );
        return result.data;
    },
    createVehicleCmsData: async function (data: object) {
        const result = await backendApi.post("/vehicle-model-cms", data);
        return result.data;
    },
    updateVehicleCmsData: async function (id: string, data: object) {
        const result = await backendApi.put(`/vehicle-model-cms/${id}`, data);
        return result.data;
    },
    getVehicleByOdooId: async function (odooId: number) {
        const result = await backendApi.get(
            `/vehicle/get-by-odoo-id/${odooId}`,
        );
        return result.data;
    },
    getShippingList: async function (
        fromDate?: string,
        toDate?: string,
        params?: any,
    ) {
        let filter: any = params || {};
        if (fromDate) filter.fromDate = fromDate;
        if (toDate) filter.toDate = toDate;

        const result = await backendApi.get(`/shipping-report`, {
            params: filter,
        });

        return result.data;
    },
    getRFQList: async function () {
        const result = await backendApi.get("/shipping-report/rfq", {});
        return result.data;
    },
    getBLList: async function () {
        const result = await backendApi.get("/shipping-report/bl", {});
        return result.data;
    },
    getSoList: async function (filter = {}) {
        const result = await backendApi.get("/shipping-report/so-updated", {
            params: filter,
        });
        return result.data;
    },
    getDeliveryList: async function (
        fromDate?: string,
        toDate?: string,
        params?: any,
    ) {
        let filter: any = params || {};
        if (fromDate) filter.fromDate = fromDate;
        if (toDate) filter.toDate = toDate;

        console.log("filter:", filter);

        const result = await backendApi.get(`/shipping-report/delivery`, {
            params: filter,
        });

        return result.data;
    },
};

export default API;
